import siteConfig from "../../../site-config.json"

export const publicConfig = siteConfig

export const IS_LOCAL_DEV = process.env.NODE_ENV === "development"

export const IS_DEV_ENV = IS_LOCAL_DEV || process.env.NEXT_PUBLIC_ENV === "dev"

export const IS_ANALYTICS_ENABLED = !!process.env.NEXT_PUBLIC_ENABLE_ANALYTICS
